module.exports = __webpack_public_path__ + "img/divide58-3.f3518db5.svg";